// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"418":"ff959c2f","787":"9e9f4ffd","932":"4a321ebd"}[chunkId] + ".chunk.js";
};